import { create } from 'zustand';

export interface CountState {
  count: number;
  increaseCount: () => void;
  increaseCountBy: (by: number) => void;
  decreaseCount: () => void;
  reset: () => void;
}

const initialState = {
  count: 0,
};

export const useCountStore = create<CountState>()((set) => ({
  ...initialState,
  increaseCount: () => set((state) => ({ count: state.count + 1 })),
  increaseCountBy: (by) => set((state) => ({ count: state.count + by })),
  decreaseCount: () => set((state) => ({ count: state.count - 1 })),
  reset: () => set(initialState),
}));
